import { render } from "./createIntake.vue?vue&type=template&id=1be897a7&scoped=true"
import script from "./createIntake.vue?vue&type=script&lang=js"
export * from "./createIntake.vue?vue&type=script&lang=js"

import "./createIntake.vue?vue&type=style&index=0&id=1be897a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be897a7"]])

export default __exports__